import { useExternalRoleQuery } from './useExternalRoleQuery';
import { useExternalRolesQuery } from './useExternalRolesQuery';
import { useExternalRoleUserCountsQuery } from './useExternalRoleUserCountsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface RestoreExternalRolesMutationParams {
  roleIds: string[];
}

export const useExternalRolesRestoreMutation = createMutationHook(
  'settings.customerPortal.restoreRoles',
  (params: RestoreExternalRolesMutationParams) => ({
    coreRolesRestore: {
      __args: {
        input: {
          roleIds: params.roleIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
  {
    invalidateQueries: [
      useExternalRolesQuery,
      useExternalRoleUserCountsQuery,
      useExternalRoleQuery,
    ],
  },
);
